export default __webpack_public_path__ + "static/media/IconRightArrow.4ccddf11.svg";